import { Button, Input, Select, Tabs, Card, Typography, Row, Col } from "antd";
import { MinusOutlined, PlusOutlined, CloseOutlined } from "@ant-design/icons";
import { Scrollbars } from "react-custom-scrollbars";
import CancelArrow from "../../assets/images/cancelArrow.svg";
import DefaultProductImage from "../../assets/images/no-image.svg";
import ScaleIcon from "../../assets/images/scale.svg";

const { TabPane } = Tabs;
const { Title, Paragraph } = Typography;

const ProductDetailPanel = ({
  selectedProduct,
  posConfig,
  hasReverseOrderData,
  tempQuantityInputValue,
  setTempQuantityInputValue,
  updateQuantityAndProducts,
  setQtyShowInputFields,
  setIsFirstInput,
  setShowInputFields,
  totalWeight,
  setTotalWeight,
  setTareWeight,
  searchedProductsData,
  checkStockData,
  savingTotalWeightFn,
  handleGetWeight,
  tareWeight,
  savingTareWeightFn,
  quantityInputValue,
  formattedDate,
  expiryDate,
  copies,
  savingCopiesFn,
  setCopies,
  otherChargesData,
  showAltUnderline,
  handleOtherChanges,
  currenciesList,
  pricePrecision,
  totalSalePrice,
  totalWeights,
  remarks,
  setShowRemarks,
  setTempRemarks,
  pricingMethod,
  setPricingMethod,
  savingPricingMethodFn,
  pricingMethodRef,
  plusButtonRef,
  showInputFields,
  posConfigEnableQtyUnitKeypad: enableQtyUnitKeypad,
  posConfigEnableTotalQtyKeypad: enableTotalQtyKeypad,
  activeTabKey,
  setActiveTabKey,
  setIsNewInput,
  qtyInputRef,
  totalQtyRef,
  selectedQuantity,
  setSelectedQuantity,
  selectedKey,
  selectedRowKey,
  handleAmount,
  handleEnter,
  decrementQuantity,
  incrementQuantity,
  handleTotalAmount,
  handleTotalEnter,
  decrementTotalQuantity,
  incrementTotalQuantity,
  selectedTotalQuantity,
  setSelectedTotalQuantity,
  setSelectedRowKey,
  QtyShowInputFields,
  setQtyShowInputFields: setQtyShowInputFieldsOuter,
  setKeyBoardInputValue,
  keyBoardInputValue,
  inputRef,
  handleAmountQty,
  handleEnterQty,
  decrementQuantity1,
  incrementQuantity1,
  handleCancel,
  handleProceed,
  handleChooseProduct,
  chooseAProductLoading,
  buttonRef,
}) => {
  return (
    <div
      style={{
        width: "35.6%",
        padding: "0% 0% 0 0.4%",
        borderRadius: "7px",
        paddingBottom: "0",
        height: "89.5vh",
        marginRight: "1%",
        backgroundColor: "#fff",
        position: "relative",
        fontSize: "1vw",
        border: "1px solid #ccc",
      }}
    >
      {selectedProduct !== null ? (
        <div
          style={{
            padding: "16px",
            background: "#ffffff",
            borderRadius: "8px",
            height: "87vh",
            position: "relative",
          }}
        >
          <Scrollbars autoHide style={{ height: "80vh" }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
              <img src={selectedProduct?.imageurl ? selectedProduct?.imageurl : DefaultProductImage} alt="Product" style={{ width: "15%", marginRight: "16px" }} />
              <div>
                <h3 style={{ margin: "0", fontSize: "13px", fontWeight: 700 }}>
                  {selectedProduct?.name ? `${selectedProduct?.value} - ${selectedProduct?.name}` : `${selectedProduct?.value} - ${selectedProduct?.product}`}
                </h3>
                {posConfig?.showTareWeight === "Y" ? null : (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span style={{ fontSize: "1.1em", fontWeight: 400, color: "#0F0718", marginRight: "8px" }}>Qty:</span>
                    <Button
                      icon={<MinusOutlined style={{ fontSize: "15px" }} />}
                      style={{
                        width: "30px",
                        height: "28px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        paddingRight: 6,
                        marginRight: "15px",
                        paddingLeft: 6,
                        borderRadius: "5px",
                        paddingTop: 0,
                      }}
                      onClick={() => {
                        setTempQuantityInputValue((prevValue) => {
                          const newQuantity = Math.max(1, parseInt(prevValue) - 1);
                          updateQuantityAndProducts(newQuantity);
                          return newQuantity;
                        });
                      }}
                      disabled={hasReverseOrderData}
                    />
                    <Input
                      tabIndex={0}
                      type="text"
                      value={tempQuantityInputValue}
                      style={{ width: "70px", textAlign: "center" }}
                      onPressEnter={(e) => {
                        e.preventDefault();
                        const finalValue = tempQuantityInputValue === "" ? 1 : Number(tempQuantityInputValue);
                        updateQuantityAndProducts(finalValue);
                        setQtyShowInputFields(false);
                        e.target.blur();
                      }}
                      onFocus={() => {
                        setQtyShowInputFields(true);
                        setIsFirstInput(true);
                        setShowInputFields(false);
                      }}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length <= 4) {
                          const sanitizedValue =
                            selectedProduct && Array.isArray(selectedProduct.uomData) && selectedProduct.uomData[0] && selectedProduct.uomData[0].decimal === "Y"
                              ? value.replace(/[^0-9.]/g, "").replace(/(\..*?)\./g, "$1")
                              : value.replace(/[^0-9]/g, "");
                          setTempQuantityInputValue(sanitizedValue);
                        }
                      }}
                      disabled={hasReverseOrderData}
                    />
                    <Button
                      icon={<PlusOutlined style={{ fontSize: "15px", color: "#fff" }} />}
                      style={{
                        width: "30px",
                        height: "28px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        paddingRight: 6,
                        marginLeft: "15px",
                        paddingLeft: 6,
                        backgroundColor: "#2F3856",
                        borderRadius: "5px",
                      }}
                      onClick={() => {
                        setTempQuantityInputValue((prevValue) => {
                          const newQuantity = Math.max(1, parseInt(prevValue) + 1);
                          updateQuantityAndProducts(newQuantity);
                          return newQuantity;
                        });
                      }}
                      disabled={hasReverseOrderData}
                    />
                  </div>
                )}
              </div>
            </div>
            <div style={{ marginBottom: "16px" }}>
              {posConfig?.showTareWeight === "Y" && (
                <>
                  <img src={ScaleIcon} alt="Small Product" style={{ width: "4%", marginRight: "8px" }} />
                  <span style={{ fontWeight: 700, fontSize: "12px", marginRight: "14px" }}>Weight Details</span>
                  <hr style={{ margin: "10px 0" }} />
                </>
              )}
              {posConfig?.showTareWeight === "Y" && (
                <div style={{ marginBottom: "12px", fontWeight: 600, fontSize: "13px" }}>
                  <span style={{ marginRight: "40px" }}>Total weight ({selectedProduct?.ediCode})</span>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Input
                      style={{ width: "70%" }}
                      value={totalWeight}
                      onChange={(e) => {
                        setTareWeight((prevValue) => {
                          const finalValue = e.target.value === "" ? 0 : parseFloat(e.target.value - (prevValue || 0));
                          updateQuantityAndProducts(Math.max(0, finalValue));
                          const modifiedProductData = searchedProductsData?.map((product) => ({
                            ...product,
                            totalWeight: product.weight * finalValue,
                            total: product.weight * finalValue * product.sale_price,
                          }));
                          let stockFlag = checkStockData(modifiedProductData);
                          if (!stockFlag) {
                            savingTotalWeightFn(e.target.value);
                            setTotalWeight(e.target.value);
                          }
                          return prevValue;
                        });
                      }}
                    />
                    <Button style={{ height: "32px", background: "black", color: "white", borderRadius: "5px" }} onClick={() => handleGetWeight()}>
                      Get Weight
                    </Button>
                  </div>
                </div>
              )}
              {posConfig?.showTareWeight === "Y" && (
                <div style={{ marginBottom: "12px", fontWeight: 600, fontSize: "13px" }}>
                  <span>Tare weight ({selectedProduct?.ediCode})</span>
                  <Input
                    style={{ width: "100%" }}
                    value={tareWeight}
                    onChange={(e) => {
                      setTotalWeight((prevValue) => {
                        const finalValue = e.target.value === "" ? 0 : parseFloat((prevValue || 0) - e.target.value);
                        updateQuantityAndProducts(Math.max(0, finalValue));
                        const modifiedProductData = searchedProductsData?.map((product) => ({
                          ...product,
                          totalWeight: product.weight * finalValue,
                          total: product.weight * finalValue * product.sale_price,
                        }));
                        let stockFlag = checkStockData(modifiedProductData);
                        if (!stockFlag) {
                          savingTareWeightFn(e.target.value);
                          setTareWeight(e.target.value);
                        }
                        return prevValue;
                      });
                    }}
                  />
                </div>
              )}
              {posConfig?.showTareWeight === "Y" && (
                <div
                  style={{
                    marginBottom: "12px",
                    backgroundColor: "#f0f0f0",
                    padding: "8px",
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "3px",
                  }}
                >
                  <span style={{ fontSize: "11px", fontWeight: 600, marginTop: "6px", marginLeft: "6px" }}>Actual weight</span>
                  <span style={{ fontSize: "18px", fontWeight: "bold", marginLeft: "6px" }}>
                    {quantityInputValue} {selectedProduct?.ediCode}
                  </span>
                </div>
              )}
              <div style={{ marginBottom: "12px" }}>
                <span style={{ marginBottom: "12px", fontWeight: 600, fontSize: "13px" }}>Production Date</span>
                <p style={{ fontWeight: 500, color: "#0F0718", fontSize: "1.3em", margin: 0 }}>{formattedDate}</p>
              </div>
              {posConfig?.showTareWeight === "Y" && (
                <div style={{ marginBottom: "12px" }}>
                  <span style={{ marginBottom: "12px", fontWeight: 600, fontSize: "13px" }}>Expiry Date</span>
                  <p style={{ fontWeight: 500, color: "#0F0718", fontSize: "1.3em", margin: 0 }}>{expiryDate}</p>
                </div>
              )}
              {posConfig?.showTareWeight === "Y" && (
                <div style={{ marginBottom: "12px" }}>
                  <span style={{ marginBottom: "12px", fontWeight: 600, fontSize: "13px" }}>No. of Labels</span>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Input
                      type="number"
                      style={{ width: "100%" }}
                      value={copies}
                      onChange={(e) => {
                        savingCopiesFn(e.target.value);
                        setCopies(e.target.value);
                      }}
                    />
                  </div>
                </div>
              )}
              {posConfig?.enableOtherCharges === "Y" && (
                <div style={{ marginBottom: "12px" }}>
                  <span style={{ marginBottom: "12px", fontWeight: 600, fontSize: "13px" }}>
                    {showAltUnderline ? (
                      <>
                        <u>O</u>ther Charges
                      </>
                    ) : (
                      "Other Charges"
                    )}
                  </span>
                  <PlusOutlined
                    tabIndex={3}
                    ref={plusButtonRef}
                    style={{
                      cursor: hasReverseOrderData ? "not-allowed" : "pointer",
                      opacity: hasReverseOrderData ? 0.5 : 1,
                    }}
                    onClick={(e) => {
                      if (!hasReverseOrderData) {
                        handleOtherChanges();
                      }
                    }}
                  />
                  {otherChargesData?.some((item) => item.weight) &&
                    otherChargesData?.map(
                      (item, index) =>
                        item?.weight && (
                          <div key={index} style={{ marginTop: "3vh", display: "flex", alignItems: "center" }}>
                            <div style={{ marginLeft: "1.5vw", display: "flex", alignItems: "center", flex: "0 0 33.33%" }}>
                              <p style={{ fontWeight: 400, fontSize: "1em", color: "#0F0718", margin: 0 }}>{item?.name}</p>
                            </div>
                            <div style={{ flex: "0 0 4.17%" }} />
                            <div style={{ display: "flex", alignItems: "center", flex: "0 0 37.5%" }}>
                              <p style={{ fontWeight: 500, color: "#0F0718", fontSize: "1em", margin: 0 }}>
                                {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                                {item?.weight}
                                <span style={{ marginLeft: "2px", marginTop: 0 }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
                              </p>
                            </div>
                          </div>
                        )
                    )}
                </div>
              )}
              <div style={{ marginBottom: "12px" }}>
                <span style={{ marginBottom: "12px", fontWeight: 600, fontSize: "13px" }}>
                  {showAltUnderline ? (
                    <>
                      Re<u>m</u>arks
                    </>
                  ) : (
                    "Remarks"
                  )}
                </span>
                <Input.TextArea
                  style={{ width: "100%", resize: "none", border: "1px solid #92909880", color: "#0F0718", fontSize: "1em", fontWeight: 500, height: "32px", cursor: hasReverseOrderData ? "not-allowed" : "pointer" }}
                  value={remarks}
                  readOnly
                  onClick={() => {
                    if (hasReverseOrderData) return;
                    setShowRemarks(true);
                    setTempRemarks(remarks);
                  }}
                  disabled={hasReverseOrderData}
                />
              </div>
              {selectedProduct?.productmanufacturing &&
                selectedProduct?.productmanufacturing[0]?.standard_price &&
                selectedProduct?.productmanufacturing[0]?.standard_price === "Y" && (
                  <div style={{ marginBottom: "12px" }}>
                    <span style={{ marginBottom: "12px", fontWeight: 600, fontSize: "13px" }}>Pricing Method</span>
                    <Select
                      tabIndex={4}
                      ref={pricingMethodRef}
                      value={pricingMethod}
                      style={{ width: "100%", border: "1px solid #d9d9d9", borderRadius: "4px" }}
                      placeholder="Select"
                      onChange={(value) => {
                        setPricingMethod(value);
                        savingPricingMethodFn(value);
                      }}
                      disabled={true}
                    >
                      <Select.Option value="Standard Price">Standard Price</Select.Option>
                      <Select.Option value="BOM Price">BOM Price</Select.Option>
                    </Select>
                  </div>
                )}
              {posConfig?.showSalePriceUnit === "Y" && (
                <div style={{ marginBottom: "12px" }}>
                  <span style={{ marginBottom: "12px", fontWeight: 600, fontSize: "13px" }}>Sale Price/Unit</span>
                  <p style={{ fontWeight: 500, color: "#0F0718", fontSize: "1.3em", margin: 0 }}>
                    {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                    {(totalSalePrice + totalWeights).toFixed(pricePrecision)}
                    <span style={{ marginLeft: "2px", marginTop: 0 }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
                  </p>
                </div>
              )}
              {posConfig?.showTotalPrice === "Y" && (
                <div style={{ marginBottom: "12px" }}>
                  <span style={{ marginBottom: "12px", fontWeight: 600, fontSize: "13px" }}>Total Price</span>
                  <p style={{ fontWeight: 500, color: "#0F0718", fontSize: "1.3em", margin: 0 }}>
                    {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                    {(totalSalePrice * quantityInputValue + totalWeights * quantityInputValue).toFixed(pricePrecision)}
                    <span style={{ marginLeft: "2px", marginTop: 0 }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
                  </p>
                </div>
              )}
            </div>
          </Scrollbars>
          {showInputFields && (enableQtyUnitKeypad === "Y" || enableTotalQtyKeypad === "Y") ? (
            <Tabs
              defaultActiveKey="1"
              onChange={(key) => {
                setIsNewInput(true);
                setActiveTabKey(key);
                if (key === "1") {
                  requestAnimationFrame(() => {
                    qtyInputRef.current?.focus();
                    qtyInputRef.current?.select();
                  });
                } else if (key === "2") {
                  requestAnimationFrame(() => {
                    totalQtyRef.current?.focus();
                    totalQtyRef.current?.select();
                  });
                } else if (key === "3") {
                  setSelectedRowKey(null);
                  setShowInputFields(false);
                  setSelectedQuantity(0);
                  setSelectedTotalQuantity(0);
                }
              }}
              className="custom-tabs"
              style={{
                position: "absolute",
                top: showInputFields ? "48%" : "100%",
                left: "0",
                width: "100%",
                height: "auto",
                background: "rgba(255, 255, 255, 0.95)",
                zIndex: 1000,
                transition: "top 0.5s ease",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
              }}
            >
              {enableQtyUnitKeypad === "Y" && (
                <TabPane tab="Qty/Unit" key="1" className="custom-tabpane">
                  <Row style={{ margin: "0 0 0 0" }}>
                    <Input
                      ref={qtyInputRef}
                      className="productSearch sm-payment-search totalQtyInput"
                      style={{
                        borderRadius: "0.5vw",
                        height: "7.3vh",
                        margin: "0 1% 2.7% 3.5%",
                        borderRadius: "5px",
                        textAlign: "right",
                        fontWeight: "500",
                        fontSize: "2.5em",
                        borderColor: "#92909880",
                        color: "#2F3856",
                      }}
                      id="sm-amount-input"
                      placeholder="Enter Quantity"
                      value={selectedQuantity}
                      onPressEnter={(e) => {
                        e.preventDefault();
                        handleEnter();
                      }}
                      onChange={(e) => {
                        const value = e.target.value;
                        const sanitizedValue =
                          selectedRowKey !== null && searchedProductsData[selectedKey]?.uomData[0]?.decimal === "Y"
                            ? value.replace(/[^0-9.]/g, "").replace(/(\..*?)\./g, "$1")
                            : value.replace(/[^0-9]/g, "");
                        setSelectedQuantity(sanitizedValue);
                      }}
                    />
                  </Row>
                  <Row style={{ padding: "0 1% 0 3.5%" }} gutter={[8, 6]}>
                    <Col span={6}>
                      <button id="sm-amount-button1" className="amt-dial-btn-market" onClick={() => handleAmount("1")}>1</button>
                    </Col>
                    <Col span={6}>
                      <button id="sm-amount-button2" className="amt-dial-btn-market" onClick={() => handleAmount("2")}>2</button>
                    </Col>
                    <Col span={6}>
                      <button id="sm-amount-button3" className="amt-dial-btn-market" onClick={() => handleAmount("3")}>3</button>
                    </Col>
                    <Col span={6}>
                      <button
                        className="amt-dial-btn-market"
                        id="sm-amount-buttonRemove"
                        onClick={() => handleAmount("x")}
                        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                      >
                        <img src={CancelArrow} alt="back space" style={{ width: "1.4vw", height: "1.4vw", objectFit: "contain" }} />
                      </button>
                    </Col>
                    <Col span={6}>
                      <button id="sm-amount-button4" className="amt-dial-btn-market" onClick={() => handleAmount("4")}>4</button>
                    </Col>
                    <Col span={6}>
                      <button id="sm-amount-button5" className="amt-dial-btn-market" onClick={() => handleAmount("5")}>5</button>
                    </Col>
                    <Col span={6}>
                      <button id="sm-amount-button6" className="amt-dial-btn-market" onClick={() => handleAmount("6")}>6</button>
                    </Col>
<Col span={6}>
  <div
    style={{
      display: "flex",
      gap: "8px",
      width: "100%",
    }}
  >
    <button
      id="sm-amount-decrementQuantity"
      className="amt-dial-btn-market"
      style={{
        flex: 1,
        fontSize: "1.8em",
        fontWeight: 600,
      }}
      onClick={decrementQuantity}
    >
      -
    </button>

    <button
      id="sm-amount-incrementQuantity"
      className="amt-dial-btn-market"
      style={{
        flex: 1,
        fontSize: "1.8em",
        fontWeight: 600,
      }}
      onClick={incrementQuantity}
    >
      +
    </button>
  </div>
</Col>
                    <Col span={18}>
                      <Row gutter={[8, 6]}>
                        <Col span={8}>
                          <button id="sm-amount-button7" className="amt-dial-btn-market" onClick={() => handleAmount("7")}>7</button>
                        </Col>
                        <Col span={8}>
                          <button id="sm-amount-button8" className="amt-dial-btn-market" onClick={() => handleAmount("8")}>8</button>
                        </Col>
                        <Col span={8}>
                          <button id="sm-amount-button9" className="amt-dial-btn-market" onClick={() => handleAmount("9")}>9</button>
                        </Col>
                        <Col span={8}>
                          <button id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleAmount("0")}>0</button>
                        </Col>
                        <Col span={8}>
                          <button id="sm-amount-button00" className="amt-dial-btn-market" onClick={() => handleAmount("00")}>00</button>
                        </Col>
                        <Col span={8}>
                          <button
                            id="sm-amount-button."
                            className="amt-dial-btn-market"
                            style={{ cursor: selectedRowKey !== null && searchedProductsData[selectedKey]?.uomData[0]?.decimal === "Y" ? "pointer" : "not-allowed" }}
                            onClick={() => handleAmount(".")}
                          >.</button>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={6}>
                      <button id="sm-amount-buttonEnter" className="amt-dial-btn-market2" onClick={handleEnter}>Enter</button>
                    </Col>
                  </Row>
                </TabPane>
              )}
              {enableTotalQtyKeypad === "Y" && (
                <TabPane tab="Total Qty" key="2" className="custom-tabpane">
                  <Row style={{ margin: "0 0 0 0" }}>
                    <Input
                      ref={totalQtyRef}
                      className="productSearch sm-payment-search totalInput"
                      style={{
                        borderRadius: "0.5vw",
                        height: "7.3vh",
                        margin: "0 1% 2.7% 3.5%",
                        borderRadius: "5px",
                        textAlign: "right",
                        fontWeight: "500",
                        fontSize: "2.5em",
                        borderColor: "#92909880",
                        color: "#2F3856",
                      }}
                      onPressEnter={(e) => {
                        e.preventDefault();
                        handleTotalEnter();
                      }}
                      id="sm-total-amount-input"
                      placeholder="Enter Quantity"
                      value={selectedTotalQuantity}
                      onChange={(e) => {
                        const value = e.target.value;
                        const sanitizedValue =
                          selectedRowKey !== null && searchedProductsData[selectedKey]?.uomData[0]?.decimal === "Y"
                            ? value.replace(/[^0-9.]/g, "").replace(/(\..*?)\./g, "$1")
                            : value.replace(/[^0-9]/g, "");
                        setSelectedTotalQuantity(sanitizedValue);
                      }}
                    />
                  </Row>
                  <Row style={{ padding: "0 1% 0 3.5%" }} gutter={[8, 6]}>
                    <Col span={6}>
                      <button id="sm-amount-button1" className="amt-dial-btn-market" onClick={() => handleTotalAmount("1")}>1</button>
                    </Col>
                    <Col span={6}>
                      <button id="sm-amount-button2" className="amt-dial-btn-market" onClick={() => handleTotalAmount("2")}>2</button>
                    </Col>
                    <Col span={6}>
                      <button id="sm-amount-button3" className="amt-dial-btn-market" onClick={() => handleTotalAmount("3")}>3</button>
                    </Col>
                    <Col span={6}>
                      <button
                        className="amt-dial-btn-market"
                        id="sm-amount-buttonRemove"
                        onClick={() => handleTotalAmount("x")}
                        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                      >
                        <img src={CancelArrow} alt="back space" style={{ width: "1.4vw", height: "1.4vw", objectFit: "contain" }} />
                      </button>
                    </Col>
                    <Col span={6}>
                      <button id="sm-amount-button4" className="amt-dial-btn-market" onClick={() => handleTotalAmount("4")}>4</button>
                    </Col>
                    <Col span={6}>
                      <button id="sm-amount-button5" className="amt-dial-btn-market" onClick={() => handleTotalAmount("5")}>5</button>
                    </Col>
                    <Col span={6}>
                      <button id="sm-amount-button6" className="amt-dial-btn-market" onClick={() => handleTotalAmount("6")}>6</button>
                    </Col>
<Col span={6}>
  <div
    style={{
      display: "flex",
      gap: "8px",
      width: "100%",
    }}
  >
    <button
      id="sm-amount-decrementTotalQuantity"
      className="amt-dial-btn-market-qty"
      style={{
        flex: 1,
        fontSize: "1.8em",
        fontWeight: 600,
        cursor:
          selectedRowKey !== null &&
          searchedProductsData[selectedKey]?.uomData?.[0]?.decimal === "Y"
            ? "not-allowed"
            : "pointer",
      }}
      onClick={
        selectedRowKey !== null &&
        searchedProductsData[selectedKey]?.uomData?.[0]?.decimal === "Y"
          ? null
          : decrementTotalQuantity
      }
    >
      -
    </button>

    <button
      id="sm-amount-incrementTotalQuantity"
      className="amt-dial-btn-market-qty"
      style={{
        flex: 1,
        fontSize: "1.8em",
        fontWeight: 600,
        cursor:
          selectedRowKey !== null &&
          searchedProductsData[selectedKey]?.uomData?.[0]?.decimal === "Y"
            ? "not-allowed"
            : "pointer",
      }}
      onClick={
        selectedRowKey !== null &&
        searchedProductsData[selectedKey]?.uomData?.[0]?.decimal === "Y"
          ? null
          : incrementTotalQuantity
      }
    >
      +
    </button>
  </div>
</Col>
                    <Col span={18}>
                      <Row gutter={[8, 6]}>
                        <Col span={8}>
                          <button id="sm-amount-button7" className="amt-dial-btn-market" onClick={() => handleTotalAmount("7")}>7</button>
                        </Col>
                        <Col span={8}>
                          <button id="sm-amount-button8" className="amt-dial-btn-market" onClick={() => handleTotalAmount("8")}>8</button>
                        </Col>
                        <Col span={8}>
                          <button id="sm-amount-button9" className="amt-dial-btn-market" onClick={() => handleTotalAmount("9")}>9</button>
                        </Col>
                        <Col span={8}>
                          <button id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleTotalAmount("0")}>0</button>
                        </Col>
                        <Col span={8}>
                          <button id="sm-amount-button00" className="amt-dial-btn-market" onClick={() => handleTotalAmount("00")}>00</button>
                        </Col>
                        <Col span={8}>
                          <button
                            id="sm-amount-button."
                            className="amt-dial-btn-market"
                            style={{ cursor: selectedRowKey !== null && searchedProductsData[selectedKey]?.uomData[0]?.decimal === "Y" ? "pointer" : "not-allowed" }}
                            onClick={() => handleTotalAmount(".")}
                          >.</button>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={6}>
                      <button id="sm-amount-buttonEnter" className="amt-dial-btn-market2" onClick={handleTotalEnter}>Enter</button>
                    </Col>
                  </Row>
                </TabPane>
              )}
              <TabPane
                className="custom-tabpane"
                tab={
                  <>
                    <CloseOutlined
                      style={{ marginLeft: "0.5rem", cursor: "pointer", fontSize: "17px", color: "#2F3856" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedRowKey(null);
                        setShowInputFields(false);
                        setSelectedQuantity(0);
                        setSelectedTotalQuantity(0);
                      }}
                    />
                  </>
                }
                key="3"
              ></TabPane>
            </Tabs>
          ) : QtyShowInputFields ? (
            <div
              style={{
                position: "absolute",
                top: QtyShowInputFields ? "56.5%" : "100%",
                left: "0",
                width: "100%",
                height: "auto",
                background: "rgba(255, 255, 255, 0.95)",
                zIndex: 1000,
                transition: "top 0.5s ease",
              }}
            >
              <CloseOutlined
                style={{ position: "absolute", marginTop: "1rem", right: "10px", cursor: "pointer", fontSize: "15px", color: "#2F3856", zIndex: 1001 }}
                onClick={() => {
                  setQtyShowInputFieldsOuter(false);
                  setSelectedRowKey(null);
                  setKeyBoardInputValue(quantityInputValue);
                }}
              />
              <Row style={{ margin: "0 0 0 0" }}>
                <Input
                  id="sm-qty-input"
                  ref={inputRef}
                  className="productSearch sm-payment-search totalInput"
                  style={{
                    borderRadius: "0.5vw",
                    height: "7.3vh",
                    margin: "8% 1% 2.7% 3.5%",
                    borderRadius: "5px",
                    textAlign: "right",
                    fontWeight: "500",
                    fontSize: "2.5em",
                    borderColor: "#92909880",
                    color: "#2F3856",
                  }}
                  onPressEnter={(e) => {
                    e.preventDefault();
                    handleEnterQty();
                  }}
                  onChange={(e) => {
                    const sanitizedValue =
                      selectedProduct && Array.isArray(selectedProduct.uomData) && selectedProduct.uomData[0] && selectedProduct.uomData[0].decimal === "Y"
                        ? e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*?)\./g, "$1")
                        : e.target.value.replace(/[^0-9]/g, "");
                    if (sanitizedValue.length <= 4) {
                      setKeyBoardInputValue(sanitizedValue);
                    }
                  }}
                  placeholder="Enter Amount"
                  value={keyBoardInputValue}
                />
              </Row>
              <Row style={{ padding: "0 1% 0 3.5%" }} gutter={[8, 6]}>
                <Col span={6}>
                  <button id="sm-amount-button1" className="amt-dial-btn-market" onClick={() => handleAmountQty("1")}>1</button>
                </Col>
                <Col span={6}>
                  <button id="sm-amount-button2" className="amt-dial-btn-market" onClick={() => handleAmountQty("2")}>2</button>
                </Col>
                <Col span={6}>
                  <button id="sm-amount-button3" className="amt-dial-btn-market" onClick={() => handleAmountQty("3")}>3</button>
                </Col>
                <Col span={6}>
                  <button
                    className="amt-dial-btn-market"
                    id="sm-amount-buttonRemove"
                    onClick={() => handleAmountQty("x")}
                    style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                  >
                    <img src={CancelArrow} alt="back space" style={{ width: "1.4vw", height: "1.4vw", objectFit: "contain" }} />
                  </button>
                </Col>
                <Col span={6}>
                  <button id="sm-amount-button4" className="amt-dial-btn-market" onClick={() => handleAmountQty("4")}>4</button>
                </Col>
                <Col span={6}>
                  <button id="sm-amount-button5" className="amt-dial-btn-market" onClick={() => handleAmountQty("5")}>5</button>
                </Col>
                <Col span={6}>
                  <button id="sm-amount-button6" className="amt-dial-btn-market" onClick={() => handleAmountQty("6")}>6</button>
                </Col>
                <Col span={6}>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 4 }}>
                    <button id="sm-amount-addQuantity" className="amt-dial-btn-market-qty" onClick={decrementQuantity1}>-</button>
                    <button id="sm-amount-addQuantity" className="amt-dial-btn-market-qty" onClick={incrementQuantity1}>+</button>
                  </div>
                </Col>
                <Col span={18}>
                  <Row gutter={[8, 6]}>
                    <Col span={8}>
                      <button id="sm-amount-button7" className="amt-dial-btn-market" onClick={() => handleAmountQty("7")}>7</button>
                    </Col>
                    <Col span={8}>
                      <button id="sm-amount-button8" className="amt-dial-btn-market" onClick={() => handleAmountQty("8")}>8</button>
                    </Col>
                    <Col span={8}>
                      <button id="sm-amount-button9" className="amt-dial-btn-market" onClick={() => handleAmountQty("9")}>9</button>
                    </Col>
                    <Col span={8}>
                      <button id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleAmountQty("0")}>0</button>
                    </Col>
                    <Col span={8}>
                      <button id="sm-amount-button00" className="amt-dial-btn-market" onClick={() => handleAmountQty("00")}>00</button>
                    </Col>
                    <Col span={8}>
                      <button
                        id="sm-amount-button."
                        className="amt-dial-btn-market"
                        style={{
                          cursor:
                            selectedProduct && Array.isArray(selectedProduct.uomData) && selectedProduct.uomData[0] && selectedProduct.uomData[0].decimal === "Y"
                              ? "pointer"
                              : "not-allowed",
                        }}
                        onClick={() => handleAmountQty(".")}
                      >.</button>
                    </Col>
                  </Row>
                </Col>
                <Col span={6}>
                  <button id="sm-amount-buttonEnter" className="amt-dial-btn-market2" onClick={handleEnterQty}>Enter</button>
                </Col>
              </Row>
            </div>
          ) : (
            <div style={{ display: "flex", gap: "8px", position: "absolute", bottom: 0, width: "92%" }}>
              <Button style={{ width: "100%", height: "32px", borderRadius: "5px" }} onClick={handleCancel}>
                {showAltUnderline ? (
                  <>C<u>a</u>ncel</>
                ) : (
                  "Cancel"
                )}
              </Button>
              <Button
                style={{ width: "100%", height: "32px", background: "black", color: "white", borderRadius: "5px" }}
                onClick={handleProceed}
                disabled={searchedProductsData?.length === 0 || (posConfig?.showTareWeight === "Y" && quantityInputValue === 0)}
              >
                {showAltUnderline ? (
                  <><u>P</u>roceed</>
                ) : (
                  "Proceed"
                )}
              </Button>
            </div>
          )}
        </div>
      ) : posConfig?.showTareWeight === "Y" ? (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexDirection: "column", gap: "12px" }}>
          <Card
            hoverable
            styles={{ marginBottom: "16px", borderRadius: "8px", cursor: "pointer", transition: "background-color 0.3s" }}
            styles={{ body: { padding: "24px" } }}
            onClick={() => handleChooseProduct("stock")}
          >
            <Title level={4} style={{ margin: 0, marginBottom: "8px" }}>
              Make to Stock (MTS)
            </Title>
            <Paragraph type="secondary" style={{ margin: 0 }}>
              Select finished goods to produce in advance based on demand forecasts. The system will fetch required raw materials automatically.
            </Paragraph>
          </Card>
          <Card
            hoverable
            styles={{ marginBottom: "16px", borderRadius: "8px", cursor: "pointer", transition: "background-color 0.3s" }}
            styles={{ body: { padding: "24px" } }}
            onClick={() => handleChooseProduct("order")}
          >
            <Title level={4} style={{ margin: 0, marginBottom: "8px" }}>
              Make to Order (MTO)
            </Title>
            <Paragraph type="secondary" style={{ margin: 0 }}>
              Select from pending Transfer orders to produce items as per immediate demand. The system will fetch the required raw materials automatically.
            </Paragraph>
          </Card>
        </div>
      ) : (
        <div style={{ paddingTop: "2.5vh", display: "flex", alignItems: "center" }}>
          <Button
            ref={buttonRef}
            style={{
              color: "#fff",
              width: "95%",
              fontWeight: 500,
              borderRadius: "7px",
              background: "#2F3856",
              fontSize: "1.4em",
              height: "14vh",
              marginLeft: "0.7vw",
            }}
            tabIndex={0}
            onFocus={(e) => {
              e.target.style.outline = "1px solid #40a9ff";
              e.target.style.boxShadow = "0 0 5px #40a9ff";
            }}
            onBlur={(e) => {
              e.target.style.outline = "none";
            }}
            onClick={handleChooseProduct}
            loading={chooseAProductLoading}
          >
            Choose a Product
          </Button>
        </div>
      )}
    </div>
  );
};

export default ProductDetailPanel;
